import { Record } from 'immutable';

import { resolve } from '../helpers/LinkMapper';
import {
    GROUP_SAVE_CODE,
    RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS,
} from '../constants/AppConstants';

const Railcard = new Record({
    id: null,
    name: null,
    code: '',
    minAdults: 0,
    maxAdults: 0,
    minChildren: 0,
    maxChildren: 0
});

Railcard.fromJSON = function (json) {
    json = json || {};

    const name = resolve(json.name).with(String);
    const code = resolve(json.code).with(String);
    const minAdults = resolve(json.minAdults).with(Number);
    const maxAdults = resolve(json.maxAdults).with(Number);
    const minChildren = resolve(json.minChildren).with(Number);
    const maxChildren = resolve(json.maxChildren).with(Number);

    let result = { name, code, minAdults, maxAdults, minChildren, maxChildren };

    return new Railcard(result);
};

Object.assign(Railcard.prototype, {
    isGroupSave () {
        return this.code === GROUP_SAVE_CODE;
    },

    mayApplyFareAndTimeRestrictions () {
        return Object.values(RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS).includes(this.code);
    },
});

export default Railcard;



// WEBPACK FOOTER //
// ./src/records/Railcard.js